import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import setActiveBrand from '../../redux/actions/carBrand';
import setSearchCars from '../../redux/actions/searchCars';
import sortCarsArray from '../../redux/actions/catalogSort';
import setShowCars from '../../redux/actions/carCard';
import setActivePage from '../../redux/actions/pagination';
import { DELAY } from '../../constants';
import { scrollPageToTop } from '../../utilites';

const carBrands = Array.from(
  new Set(startup.cars.map((el) => el.Car.Brand))
).sort();
carBrands.unshift('Show All');

const CarBrands = ({
  selectCarBrand,
  searchCars,
  sortCars,
  setCarsShowed,
  setFirstPageActive,
  orderedBy,
}) => {
  const setBrand = (brand) => {
    selectCarBrand(brand);
    const data = new Map();
    data.set('Brand', brand);
    const carsState = searchCars(startup.cars, data).payload;
    sortCars(carsState, orderedBy);
  };
  return carBrands.map((el) => (
    <li key={el}>
      <button
        type="button"
        onClick={() => {
          const scrollTarget = document.querySelector('#car-section');
          const height = scrollTarget.offsetHeight;
          scrollTarget.style.height = `${height}px`;
          setCarsShowed(false);
          setTimeout(() => {
            setTimeout(() => {
              scrollTarget.style.height = 'auto';
            }, 1000);
            setFirstPageActive();
            setBrand(el === 'Show All' ? undefined : el);
            scrollPageToTop();
          }, DELAY);
        }}
      >
        {el}
      </button>
    </li>
  ));
};

CarBrands.propTypes = {
  carBrand: propTypes.string,
  selectCarBrand: propTypes.func.isRequired,
  setCarsShowed: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  orderedBy: state.catalog.orderedBy,
});

const mapDispatchToProps = (dispatch) => ({
  selectCarBrand: (value) => dispatch(setActiveBrand(value)),
  searchCars: (cars, data) => dispatch(setSearchCars(cars, data)),
  sortCars: (cars, sortType) => dispatch(sortCarsArray(cars, sortType)),
  setCarsShowed: (value) => dispatch(setShowCars(value)),
  setFirstPageActive: () => dispatch(setActivePage(0)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarBrands);
